import React from 'react';
import {styled} from 'baseui';
import SelectCurrency from '../components/SelectCurrency';
import {getStoreDataOptions} from '../utils/storeGeoLocator';

const Wrapper = styled('div', () => ({
  width: 'auto',
  display: 'flex',
  alignItems: 'center',
}));

type Props = {
  isStorePage?: boolean;
  regionChangeTrigger?: string;
};

export default function ({isStorePage = false, regionChangeTrigger}: Props) {
  const options = getStoreDataOptions();

  return (
    <Wrapper>
      <SelectCurrency
        options={options}
        isStorePage={isStorePage}
        regionChangeTrigger={regionChangeTrigger}
      />
    </Wrapper>
  );
}
